import { lazy } from "@/pv-utils/lazy";

import { Theme } from "./Theme";

const LazyApp = lazy("box", () => import("./App"), "App");

export const AppLoader = () => (
  <Theme>
    <LazyApp />
  </Theme>
);
